export default __webpack_public_path__ + "static/media/add-icon.f42dbe17.svg";